import { render } from "./manage-service.vue?vue&type=template&id=4add9dbc"
import script from "./manage-service.vue?vue&type=script&lang=js"
export * from "./manage-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__